// src/utils/mapProjectsToJobById.js
import { fetchJobs, fetchProjects } from "./cmsAPI";
import { getCompanySlug } from "./slugUtils";

export const mapProjectsToJobById = async (jobIdOrCompany) => {
  try {
    // Load all jobs and projects from API
    const [jobs, projects] = await Promise.all([
      fetchJobs(),
      fetchProjects({ published: true })
    ]);

    // Find the specific job by its ID, company, UUID, or company slug
    const job = jobs.find(
      (job) => {
        const companySlug = getCompanySlug(job.company);
        return (
          String(job.id) === String(jobIdOrCompany) || 
          job.company === jobIdOrCompany ||
          companySlug === jobIdOrCompany
        );
      }
    );

    if (!job) {
      console.error(`Job with ID or Company "${jobIdOrCompany}" not found.`);
      return null;
    }

    // Filter projects by associated_job field (which should be job UUID or company name)
    const associatedProjects = projects.filter(
      (project) => {
        if (!project.associated_job) return false;
        // Match by job UUID or company name
        return (
          project.associated_job === job.id ||
          project.associated_job === job.company ||
          String(project.associated_job) === String(job.id)
        );
      }
    );

    // Transform projects to match expected format (body -> content)
    const transformedProjects = associatedProjects.map(project => ({
      ...project,
      content: project.body, // API returns 'body', but some code expects 'content'
    }));

    // Return the job with its associated projects
    // Map API job fields to expected format
    return {
      ...job,
      'team-size': job.team_size, // API uses team_size, but some code expects team-size
      imagePath: job.image_path || job.logo, // Support both fields
      startDate: job.start_date,
      endDate: job.end_date,
      projects: transformedProjects,
    };
  } catch (error) {
    console.error("Error mapping projects to job:", error);
    return null;
  }
};